import { useEffect, useRef, useState } from 'react'

import { Link } from 'react-router-dom'

import { DateTime } from 'luxon'

import { FiShoppingCart } from 'react-icons/fi'

import request from '../../Functions/ajax/request'

import { num } from '../../../../shared/utilities'

import CartStore from '../../../Stores/Cart'

export default function CartCountIcon ({ ...props })
{
	const [count, setCount] = useState(0);

	const store_count = CartStore.useState(function (store)
	{
		return (store.articles || [])
		.reduce((count, art) => count + num(art.quantite, 0), 0);
	});

	const _refs = useRef();

	useEffect(() =>
	{
		_refs.current ||= { };

		(async function fetchCart ()
		{
			try
			{
				var { count } = await request('/cart/get-articles-count')
				.config({ min_req_time: 0 })
				.post();
			}
			catch (update)
			{
				return;
			}

			_refs.current.time = DateTime.now().toISO();

			setCount(num(count, 0));
		})();
	},
	[]);

	useEffect(function ()
	{
		_refs.current ||= { };

		if (!_refs.current.time) return; // on est déjà en attente du fetch du dessus

		setCount(num(store_count, 0));
	},
	[store_count]);

	return (
		<Link to="/panier" className="c-header__commande"
			data-number={ String(count) }>
			<FiShoppingCart
				className="c-header__commande-icon"
				title="Accéder à ma commande"
			/>
		</Link>
	);
}